/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Session_Hard_Limit_PreferenceInputs */

const en_us2_onboarding_session_hard_limit_preference = /** @type {(inputs: Onboarding_Session_Hard_Limit_PreferenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Just a preference`)
};

const pt_br2_onboarding_session_hard_limit_preference = /** @type {(inputs: Onboarding_Session_Hard_Limit_PreferenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É só uma preferência`)
};

const es_419_onboarding_session_hard_limit_preference = /** @type {(inputs: Onboarding_Session_Hard_Limit_PreferenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo una preferencia`)
};

const pt_pt2_onboarding_session_hard_limit_preference = /** @type {(inputs: Onboarding_Session_Hard_Limit_PreferenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`É só uma preferência`)
};

const fr_fr2_onboarding_session_hard_limit_preference = /** @type {(inputs: Onboarding_Session_Hard_Limit_PreferenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juste une préférence`)
};

const de_de2_onboarding_session_hard_limit_preference = /** @type {(inputs: Onboarding_Session_Hard_Limit_PreferenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur ein Wunsch`)
};

const it_it2_onboarding_session_hard_limit_preference = /** @type {(inputs: Onboarding_Session_Hard_Limit_PreferenceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`È solo una preferenza`)
};

/**
* | output |
* | --- |
* | "Just a preference" |
*
* @param {Onboarding_Session_Hard_Limit_PreferenceInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const onboarding_session_hard_limit_preference = /** @type {((inputs?: Onboarding_Session_Hard_Limit_PreferenceInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Session_Hard_Limit_PreferenceInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_onboarding_session_hard_limit_preference(inputs)
	if (locale === "es-419") return es_419_onboarding_session_hard_limit_preference(inputs)
	if (locale === "pt-PT") return pt_pt2_onboarding_session_hard_limit_preference(inputs)
	if (locale === "fr-FR") return fr_fr2_onboarding_session_hard_limit_preference(inputs)
	if (locale === "de-DE") return de_de2_onboarding_session_hard_limit_preference(inputs)
	if (locale === "it-IT") return it_it2_onboarding_session_hard_limit_preference(inputs)
	return en_us2_onboarding_session_hard_limit_preference(inputs)
});
export { onboarding_session_hard_limit_preference as "onboarding.session_hard_limit.preference" }